// import React, { useState, useEffect } from 'react';
// import { FaAddressCard, FaUser, FaCheckCircle, FaFileAlt } from 'react-icons/fa'; // For Icons
// import { Container, Button, Form } from 'react-bootstrap';
// import { useNavigate } from "react-router-dom";
// import axios from 'axios';


// const StakeHolderDetails = () => {
//   const [currentStep, setCurrentStep] = useState(0);
//   const BaseUrl = process.env.REACT_APP_API;

//   const [stackholders, setstackholders] = useState([]);
//   const steps = [
//     { name: 'Partner/Director', icon: <FaAddressCard onClick={() => setCurrentStep(0)}/> },
//     { name: 'Identity', icon: <FaUser onClick={() => setCurrentStep(1)}/> },
//     { name: 'Attachments', icon: <FaFileAlt onClick={() => setCurrentStep(2)}/> },
    
//   ];
//   const navigate = useNavigate();

//   const handleNext = () => {
//     if (currentStep < steps.length - 1) {
//       setCurrentStep(currentStep + 1);
//     }
//   };

//   const handlePrevious = () => {
//     if (currentStep > 0) {
//       setCurrentStep(currentStep - 1);
//     }
//   };

//   const handleSubmit = () => {
//     navigate("/");
//   };


//   useEffect(() => {
//     const fetchStackholders = async () => {
//       try {
//         const jwtToken = sessionStorage.getItem("authToken");
//         if (!jwtToken) {
//           throw new Error("JWT token not found in session storage");
//         }
  
//         const response = await axios.get(`${BaseUrl}/getStackholder`, {
//           headers: {
//             Authorization: `Bearer ${jwtToken}`,
//           },
//         });
  
//         if (response.data.length > 0) {
//           setstackholders(response.data);
//         }
//       } catch (error) {
//         console.error(error.message || "Error fetching stackholders");
//       }
//     };
  
//     fetchStackholders();
//   }, [BaseUrl]);

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const day = String(date.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

  
//   return (
//     <div id="msformsfdsd" className="container mt-4">
//       {/* Progress Bar */}
//       <ul id="progressbar" className="progress-bar d-flex justify-content-around list-unstyled flex-row">
//         {steps.map((step, index) => (
//           <li
//             key={index}
//             className={`text-center ${index <= currentStep ? 'active' : ''}`}
//             id={step.name.toLowerCase().replace(' ', '')}
//           >
//             <div className="step-icon mb-1">{step.icon}</div>
//             <span>{step.name}</span>
//           </li>
//         ))}
//       </ul>
  
//       {/* Partner/Director */}
//       <Container className="mt-5">
//         <Form>
//         {stackholders.length === 0 ? (
//             <div className="text-center">
//               <h4>No Stakeholder Added</h4>
//             </div>
//           ) : (
//           stackholders.map((stakeholder, index) => (
//             <React.Fragment key={index}>
//               {/* Partner/Director Section */}
//               <fieldset
//                 style={{
//                   padding: "20px",
//                   display: currentStep === 0 ? "block" : "none",
//                   borderRadius: "10px",
//                   boxShadow: "0px 0px 20px #748292",
//                   transition: "all 0.5s ease-in-out",
//                   textAlign: "left",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
//                   Partner/Director {index + 1}
//                 </h6>
//                 <hr
//                   style={{
//                     margin: "5px",
//                     border: "1px solid #748292",
//                     width: "100%",
//                   }}
//                 />
  
//                 {/* Full Name */}
//                 <div className="row mb-3">
//                   <label className="col-md-3 col-form-label text-start">Full Name *</label>
//                   <div className="col-md-9">
//                     <input
//                       type="text"
//                       className="form-control shadow-sm"
//                       placeholder="Enter your full legal name"
//                       value={stakeholder.family_name}
//                       required
//                     />
//                   </div>
//                 </div>
  
//                 {/* Other Name */}
//                 <div className="row mb-3">
//                   <label className="col-md-3 col-form-label text-start">Given Name</label>
//                   <div className="col-md-9">
//                     <input
//                       type="text"
//                       className="form-control shadow-sm"
//                       placeholder="Enter any other name"
//                       value={stakeholder.given_name}
//                     />
//                   </div>
//                 </div>
  
//                 {/* % of ownership in company */}
//                 <div className="row mb-3">
//                   <label className="col-md-3 col-form-label text-start">% of ownership in company</label>
//                   <div className="col-md-9">
//                     <input
//                       type="text"
//                       className="form-control shadow-sm"
//                       placeholder="Enter % of ownership in company"
//                       value={stakeholder.percentage_of_ownership}
//                     />
//                   </div>
//                 </div>
  
//                 {/* Role as a Director */}
//                 <div className="row mb-3">
//                   <label className="col-md-3 col-form-label text-start">Role as a Director</label>
//                   <div className="col-md-9">
//                     <select
//                       className="form-select"
//                       name="role_as_director"
//                       id="role_as_director"
//                       value={stakeholder.role_as_director}
//                       readOnly
//                     >
//                       <option value="">Select</option>
//                       <option value="Executive Director">Executive Director</option>
//                       <option value="Non-Executive Director">Non-Executive Director</option>
//                       <option value="Independent Director">Independent Director</option>
//                       <option value="Other">Other</option>
//                     </select>
//                   </div>
//                 </div>
  
//                 {/* Position in the Company */}
//                 <div className="row mb-3">
//                   <label htmlFor="position" className="col-md-3 col-form-label">Position in the Company</label>
//                   <div className="col-md-9">
//                     <select
//                       className="form-select"
//                       name="position"
//                       id="position"
//                       value={stakeholder.position}
//                       readonly
//                     >
//                       <option value="">Select</option>
//                       <option value="CEO">CEO</option>
//                       <option value="Dy. CEO">Dy. CEO</option>
//                       <option value="Independent Director">Independent Director</option>
//                       <option value="COO">COO</option>
//                       <option value="Dy. COO">Dy. COO</option>
//                       <option value="Asst. / Dy. GM">Asst. / Dy. GM</option>
//                       <option value="President">President</option>
//                       <option value="Vice-President">Vice-President</option>
//                       <option value="Asst. Vice President">Asst. Vice President</option>
//                       <option value="Manager">Manager</option>
//                       <option value="Head">Head</option>
//                       <option value="Dy. / Asst. Manager">Dy. / Asst. Manager</option>
//                       <option value="Sr. Executive">Sr. Executive</option>
//                       <option value="">None</option>
//                     </select>
//                   </div>
//                 </div>
  
//                 {/* Authorised Signatory */}
//                 <div className="row mb-3">
//                   <label htmlFor="is_authorised_signatory" className="col-md-3 col-form-label">Authorised Signatory</label>
//                   <div className="col-md-9">
//                     <select
//                       className="form-select"
//                       name="is_authorised_signatory"
//                       id="is_authorised_signatory"
//                       value={stakeholder.is_authorised_signatory}
//                       readonly
//                     >
//                       <option value="">Select</option>
//                       <option value="Yes">Yes</option>
//                       <option value="No">No</option>
//                     </select>
//                   </div>
//                 </div>
  
//                 {/* Type of Signing Authority */}
//                 <div className="row mb-3">
//                   <label htmlFor="type_of_signing_authority" className="col-md-3 col-form-label">Type of Signing Authority</label>
//                   <div className="col-md-9">
//                     <select
//                       className="form-select"
//                       name="type_of_signing_authority"
//                       id="type_of_signing_authority"
//                       value={stakeholder.type_of_signing_authority}
//                       readonly
//                     >
//                       <option value="">Select</option>
//                       <option value="Single / Sole">Single / Sole</option>
//                       <option value="Joint">Joint</option>
//                       <option value="Limited">Limited</option>
//                     </select>
//                   </div>
//                 </div>
  
//                 {/* PEP Name */}
//                 <div className="mb-3 row">
//                   <label htmlFor="pep_name" className="col-md-3 col-form-label">
//                     PEP Name <span className="text-muted ms-2">(Optional)</span>
//                   </label>
//                   <div className="col-md-9">
//                     <input
//                       className="form-control"
//                       type="text"
//                       name="pep_name"
//                       id="pep_name"
//                       placeholder=""
//                       value={stakeholder.pep_name}
//                       readonly
//                     />
//                   </div>
//                 </div>
  
//                 {/* Position Held */}
//                 <div className="mb-3 row">
//                   <label htmlFor="position_held" className="col-md-3 col-form-label">
//                     Position Held <span className="text-muted ms-2">(Optional)</span>
//                   </label>
//                   <div className="col-md-9">
//                     <input
//                       className="form-control"
//                       type="text"
//                       name="position_held"
//                       id="position_held"
//                       placeholder=""
//                       value={stakeholder.position_held}
//                       readonly
//                     />
//                   </div>
//                 </div>
  
//                 {/* Name of PEP Relative/Associate */}
//                 <div className="row mb-3">
//                   <label className="col-md-3 col-form-label text-start">Name of PEP Relative/Associate</label>
//                   <div className="col-md-9">
//                     <input
//                       type="text"
//                       value={stakeholder.relative_pep_name}
//                       className="form-control shadow-sm"
//                       placeholder="Enter your passport number"
//                       readOnly
//                     />
//                   </div>
//                 </div>
  
//                 {/* Relationship with PEP Name */}
//                 <div className="row mb-3">
//                   <label className="col-md-3 col-form-label text-start">Relationship with PEP Name</label>
//                   <div className="col-md-9">
//                     <input
//                       type="text"
//                       value={stakeholder.relationship_with_pep}
//                       className="form-control shadow-sm"
//                       placeholder="Enter place of issue"
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </fieldset>
  
//               {/* Identity Section */}
//               <fieldset
//                 style={{
//                   textAlign: "left",
//                   display: currentStep === 1 ? "block" : "none",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <div
//                   style={{
//                     margin: "10px",
//                     padding: "20px",
//                     borderRadius: "10px",
//                     boxShadow: "0px 0px 20px #748292",
//                     transition: "all 0.5s ease-in-out",
//                   }}
//                 >
//                   <h6 className="text-start" style={{ marginBottom: "0.7rem" }}>
//                     Identity {index + 1}
//                   </h6>
//                   <hr
//                     style={{
//                       border: "1px solid #748292",
//                       margin: "5px",
//                       width: "100%",
//                     }}
//                   />
  
//                   {/* CPR / ID / Social Security Number */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       CPR / ID / Social Security Number issued by Govt.
//                     </label>
//                     <div className="col-md-9">
//                       <input
//                         className="form-control shadow-sm"
//                         placeholder=""
//                         value={stakeholder.government_id}
//                         readOnly
//                       />
//                     </div>
//                   </div>
  
//                   {/* Date of Birth */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       Date of Birth *
//                     </label>
//                     <div className="col-md-9">
//                       <input
//                         type="date"
//                         className="form-control shadow-sm"
//                         value={formatDate(stakeholder.date_of_birth)}
//                         required
//                       />
//                     </div>
//                   </div>
  
//                   {/* Passport Number */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">Passport Number</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder=""
//                         value={stakeholder.passport_number}
//                         readOnly
//                       />
//                     </div>
//                   </div>
  
//                   {/* Date of Issue */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       Date of Issue
//                     </label>
//                     <div className="col-md-9">
//                       <input
//                         type="date"
//                         className="form-control shadow-sm"
//                         value={formatDate(stakeholder.passport_issue_date)}
//                         readOnly
//                       />
//                     </div>
//                   </div>
  
//                   {/* Expiry Date */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       Expiry Date
//                     </label>
//                     <div className="col-md-9">
//                       <input
//                         type="date"
//                         className="form-control shadow-sm"
//                         value={formatDate(stakeholder.passport_expiry_date)}
//                         readOnly
//                       />
//                     </div>
//                   </div>
  
//                   {/* Country Issued By */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">Country Issued By</label>
//                     <div className="col-md-9">
//                       <input
//                         type="email"
//                         className="form-control shadow-sm"
//                         placeholder=""
//                         value={stakeholder.issued_by}
//                         readOnly
//                       />
//                     </div>
//                   </div>
  
//                   {/* Resident of Bahrain */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       Resident of Bahrain
//                     </label>
//                     <div className="col-md-9">
//                       <select
//                         className="form-select shadow-sm"
//                         value={stakeholder.resident_of_baharain}
//                         readonly
//                       >
//                         <option value="">Select</option>
//                         <option>Yes</option>
//                         <option>No</option>
//                       </select>
//                     </div>
//                   </div>
  
//                   {/* Bahrain Residence Permit Number */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">Bahrain Residence Permit Number</label>
//                     <div className="col-md-9">
//                       <input
//                         type="email"
//                         className="form-control shadow-sm"
//                         placeholder=""
//                         value={stakeholder.bararin_residence_permit_number}
//                         readOnly
//                       />
//                     </div>
//                   </div>
  
//                   {/* Expiry Date */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       Expiry Date
//                     </label>
//                     <div className="col-md-9">
//                       <input
//                         type="date"
//                         className="form-control shadow-sm"
//                         value={formatDate(stakeholder.bararin_residence_permit_expiry_date)}
//                         readOnly
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </fieldset>
  
//               {/* Attachments Section */}
//               <fieldset
//                 style={{
//                   padding: "20px",
//                   display: currentStep === 2 ? "block" : "none",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <div
//                   style={{
//                     padding: "20px",
//                     borderRadius: "10px",
//                     boxShadow: "0px 0px 20px #748292",
//                     transition: "all 0.5s ease-in-out",
//                   }}
//                 >
//                   <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
//                     Attachments {index + 1}
//                   </h6>
//                   <hr
//                     style={{
//                       border: "1px solid #748292",
//                       margin: "5px",
//                       width: "100%",
//                     }}
//                   />
  
//                   {/* Passport Copy (First Page) */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       Passport Copy (First Page)
//                     </label>
//                     <div className="col-md-9">
//                       <input
//                         type="file"
//                         className="form-control shadow-sm"
//                         accept=".pdf"
//                         readonly={stakeholder.passport_first}
//                       />
//                       {stakeholder.passport_first && (
//                         <span
//                           className="badge badge-success"
//                           style={{
//                             marginTop: "10px",
//                             backgroundColor: "green",
//                           }}
//                         >
//                           Submitted
//                         </span>
//                       )}
//                     </div>
//                   </div>
  
//                   {/* Passport Copy (Last Page) */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       Passport Copy (Last Page)
//                     </label>
//                     <div className="col-md-9">
//                       <input
//                         type="file"
//                         className="form-control shadow-sm"
//                         accept=".pdf"
//                         readonly={stakeholder.passport_last}
//                       />
//                       {stakeholder.passport_last && (
//                         <span
//                           className="badge badge-success"
//                           style={{
//                             marginTop: "10px",
//                             backgroundColor: "green",
//                           }}
//                         >
//                           Submitted
//                         </span>
//                       )}
//                     </div>
//                   </div>
  
//                   {/* CPR Front Copy (Optional) */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       CPR Front Copy (Optional)
//                     </label>
//                     <div className="col-md-9">
//                       <input
//                         type="file"
//                         className="form-control shadow-sm"
//                         accept=".pdf"
//                         readonly={stakeholder.cpr_front}
//                       />
//                       {stakeholder.cpr_front && (
//                         <span
//                           className="badge badge-success"
//                           style={{
//                             marginTop: "10px",
//                             backgroundColor: "green",
//                           }}
//                         >
//                           Submitted
//                         </span>
//                       )}
//                     </div>
//                   </div>
  
//                   {/* CPR Back Copy (Optional) */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       CPR Back Copy (Optional)
//                     </label>
//                     <div className="col-md-9">
//                       <input
//                         type="file"
//                         className="form-control shadow-sm"
//                         accept=".pdf"
//                         readonly={stakeholder.cpr_back}
//                       />
//                       {stakeholder.cpr_back && (
//                         <span
//                           className="badge badge-success"
//                           style={{
//                             marginTop: "10px",
//                             backgroundColor: "green",
//                           }}
//                         >
//                           Submitted
//                         </span>
//                       )}
//                     </div>
//                   </div>
  
//                   {/* Residence Permit Certificate (Optional) */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">
//                       Residence Permit Certificate (Optional)
//                     </label>
//                     <div className="col-md-9">
//                       <input
//                         type="file"
//                         className="form-control shadow-sm"
//                         accept=".pdf"
//                         readonly={stakeholder.reslidence_permit_certificate}
//                       />
//                       {stakeholder.reslidence_permit_certificate && (
//                         <span
//                           className="badge badge-success"
//                           style={{
//                             marginTop: "10px",
//                             backgroundColor: "green",
//                           }}
//                         >
//                           Submitted
//                         </span>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </fieldset>
//             </React.Fragment>
//           ))
//         )}
//         </Form>
//       </Container>
  
//       {/* Action buttons */}
//       <div className="action-button-container" style={{ textAlign: "center" }}>
//         <button
//           type="button"
//           className="action-button-previous"
//           onClick={handlePrevious}
//           style={{ display: currentStep === 0 ? 'none' : 'block' }}
//         >
//           Previous
//         </button>
  
//         {currentStep === steps.length - 1 ? (
//           <button
//             type="button"
//             className="action-button"
//             onClick={handleSubmit}
//           >
//             Next
//           </button>
//         ) : (
//           <button
//             type="button"
//             className="action-button"
//             onClick={handleNext}
//             style={{ display: currentStep === steps.length - 1 ? 'none' : 'block' }}
//           >
//             Next
//           </button>
//         )}
//       </div>
//     </div>
//   );

// };

// export default StakeHolderDetails;


import React, { useState, useEffect } from 'react';
import { FaAddressCard, FaUser, FaFileAlt, FaPlus } from 'react-icons/fa';
import { Container, Button, Form, Modal } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";

const StakeHolderDetails = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const BaseUrl = process.env.REACT_APP_API;
  const [stackholders, setStackholders] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const initialFormState = {
    family_name: '',
    given_name: '',
    percentage_of_ownership: '',
    role_as_director: '',
    position: '',
    is_authorised_signatory: '',
    type_of_signing_authority: '',
    pep_name: '',
    position_held: '',
    relative_pep_name: '',
    relationship_with_pep: '',
    government_id: '',
    date_of_birth: '',
    passport_number: '',
    passport_issue_date: '',
    passport_expiry_date: '',
    issued_by: '',
    resident_of_baharain: '',
    bararin_residence_permit_number: '',
    bararin_residence_permit_expiry_date: '',
    passport_first: null,
    passport_last: null,
    cpr_front: null,
    cpr_back: null,
    reslidence_permit_certificate: null
  };

  const [formState, setFormState] = useState(initialFormState);
  const [editingIndex, setEditingIndex] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);

  const steps = [
    { name: 'Partner/Director', icon: <FaAddressCard onClick={() => setCurrentStep(0)}/> },
    { name: 'Identity', icon: <FaUser onClick={() => setCurrentStep(1)}/> },
    { name: 'Attachments', icon: <FaFileAlt onClick={() => setCurrentStep(2)}/> },
  ];
  
  const navigate = useNavigate();

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    navigate("/");
  };

  useEffect(() => {
    const fetchStackholders = async () => {
      try {
        const jwtToken = sessionStorage.getItem("authToken");
        if (!jwtToken) {
          throw new Error("JWT token not found in session storage");
        }
  
        const response = await axios.get(`${BaseUrl}/getStackholder`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
  
        if (response.data.length > 0) {
          setStackholders(response.data);
        }
      } catch (error) {
        console.error(error.message || "Error fetching stackholders");
      }
    };
  
    fetchStackholders();
  }, [BaseUrl]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleAddStakeholder = () => {
    setFormState(initialFormState);
    setEditingIndex(null);
    setIsAddingNew(true);
    setShowAddModal(true);
  };

  const handleEditStakeholder = (index) => {
    setFormState(stackholders[index]);
    setEditingIndex(index);
    setIsAddingNew(false);
    setShowAddModal(true);
  };

  const handleCloseModal = () => {
    setShowAddModal(false);
    setFormState(initialFormState);
    setEditingIndex(null);
    setIsAddingNew(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormState(prev => ({
      ...prev,
      [name]: files[0]
    }));
  };

  const handleSaveStakeholder = async () => {
    try {
      const jwtToken = sessionStorage.getItem("authToken");
      if (!jwtToken) {
        throw new Error("JWT token not found in session storage");
      }

      // Validate required fields
      const requiredFields = [
        'family_name',
        'government_id',
        'date_of_birth',
        'percentage_of_ownership',
        'role_as_director',
        'position',
        'is_authorised_signatory',
        'type_of_signing_authority'
      ];

      for (const field of requiredFields) {
        if (!formState[field]) {
          toast.error(`Please fill in the ${field.replace(/_/g, ' ')} field`);
          return;
        }
      }

      const formData = new FormData();
      
      // Append all form fields to formData
      for (const key in formState) {
        if (formState[key] !== null && formState[key] !== undefined) {
          formData.append(key, formState[key]);
        }
      }

      setLoading(true);
      
      if (isAddingNew) {
        // Add new stakeholder
        await axios.post(`${BaseUrl}/submitStakeholder`, formData, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "multipart/form-data",
          },
        });

        // Refresh stakeholders list
        const response = await axios.get(`${BaseUrl}/getStackholder`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });

        if (response.data.length > 0) {
          setStackholders(response.data);
        }

        toast.success("Stakeholder added successfully!");
      } else if (editingIndex !== null) {
        // Update existing stakeholder
        await axios.put(`${BaseUrl}/updateStackholder/${stackholders[editingIndex].id}`, formData, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "multipart/form-data",
          },
        });

        // Refresh stakeholders list
        const response = await axios.get(`${BaseUrl}/getStackholder`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });

        if (response.data.length > 0) {
          setStackholders(response.data);
        }

        toast.success("Stakeholder updated successfully!");
      }

      setLoading(false);
      handleCloseModal();
    } catch (error) {
      setLoading(false);
      console.error("Error saving stakeholder:", error);
      toast.error(error.response?.data?.message || "Error saving stakeholder");
    }
  };

  const handleDeleteStakeholder = async (index) => {
    try {
      const jwtToken = sessionStorage.getItem("authToken");
      if (!jwtToken) {
        throw new Error("JWT token not found in session storage");
      }

      if (window.confirm("Are you sure you want to delete this stakeholder?")) {
        setLoading(true);
        
        await axios.delete(`${BaseUrl}/deleteStackholder/${stackholders[index].id}`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });

        // Refresh stakeholders list
        const response = await axios.get(`${BaseUrl}/getStackholder`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });

        if (response.data.length > 0) {
          setStackholders(response.data);
        } else {
          setStackholders([]);
        }

        setLoading(false);
        toast.success("Stakeholder deleted successfully!");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error deleting stakeholder:", error);
      toast.error(error.response?.data?.message || "Error deleting stakeholder");
    }
  };

  const handleFinalSubmit = async () => {
    try {
      const jwtToken = sessionStorage.getItem("authToken");
      if (!jwtToken) {
        throw new Error("JWT token not found in session storage");
      }

      setLoading(true);
      
      await axios.post(`${BaseUrl}/finalSubmitStakeholders`, {}, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });

      setLoading(false);
      toast.success("Stakeholders submitted successfully!");
      navigate("/bankaccount");
    } catch (error) {
      setLoading(false);
      console.error("Error submitting stakeholders:", error);
      toast.error(error.response?.data?.message || "Error submitting stakeholders");
    }
  };

  return (
    <div id="msformsfdsd" className="container mt-4">
      {/* Progress Bar */}
      <ul id="progressbar" className="progress-bar d-flex justify-content-around list-unstyled flex-row">
        {steps.map((step, index) => (
          <li
            key={index}
            className={`text-center ${index <= currentStep ? 'active' : ''}`}
            id={step.name.toLowerCase().replace(' ', '')}
          >
            <div className="step-icon mb-1">{step.icon}</div>
            <span>{step.name}</span>
          </li>
        ))}
      </ul>
  
      {/* Add Stakeholder Button */}
      <div className="d-flex justify-content-end mb-3">
        <Button variant="primary" onClick={handleAddStakeholder}>
          + Add Stakeholder
        </Button>
      </div>

      {/* Stakeholder List */}
      <Container className="mt-5">
        <Form>
          {stackholders.length === 0 ? (
            <div className="text-center">
              <h4>No Stakeholder Added</h4>
            </div>
          ) : (
            stackholders.map((stakeholder, index) => (
              <React.Fragment key={index}>
                {/* <div className="d-flex justify-content-end mb-2">
                  <Button 
                    variant="warning" 
                    size="sm" 
                    className="me-2"
                    onClick={() => handleEditStakeholder(index)}
                  >
                    Edit
                  </Button>
                  <Button 
                    variant="danger" 
                    size="sm"
                    onClick={() => handleDeleteStakeholder(index)}
                  >
                    Delete
                  </Button>
                </div> */}

                {/* Partner/Director Section */}
                <fieldset
                  style={{
                    padding: "20px",
                    display: currentStep === 0 ? "block" : "none",
                    borderRadius: "10px",
                    boxShadow: "0px 0px 20px #748292",
                    transition: "all 0.5s ease-in-out",
                    textAlign: "left",
                    marginBottom: "20px",
                  }}
                >
                  <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
                    Partner/Director {index + 1}
                  </h6>
                  <hr
                    style={{
                      margin: "5px",
                      border: "1px solid #748292",
                      width: "100%",
                    }}
                  />
  
                  {/* Full Name */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">Full Name </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        placeholder="Enter your full legal name"
                        value={stakeholder.family_name}
                        required
                        readOnly
                      />
                    </div>
                  </div>
  
                  {/* Other Name */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">Given Name</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        placeholder="Enter any other name"
                        value={stakeholder.given_name}
                        readOnly
                      />
                    </div>
                  </div>
  
                  {/* % of ownership in company */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">% of ownership in company</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        placeholder="Enter % of ownership in company"
                        value={stakeholder.percentage_of_ownership}
                        readOnly
                      />
                    </div>
                  </div>
  
                  {/* Role as a Director */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">Role as a Director</label>
                    <div className="col-md-9">
                      <select
                        className="form-select"
                        name="role_as_director"
                        id="role_as_director"
                        value={stakeholder.role_as_director}
                        readOnly
                      >
                        <option value="">Select</option>
                        <option value="Executive Director">Executive Director</option>
                        <option value="Non-Executive Director">Non-Executive Director</option>
                        <option value="Independent Director">Independent Director</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
  
                  {/* Position in the Company */}
                  <div className="row mb-3">
                    <label htmlFor="position" className="col-md-3 col-form-label">Position in the Company</label>
                    <div className="col-md-9">
                      <select
                        className="form-select"
                        name="position"
                        id="position"
                        value={stakeholder.position}
                        readOnly
                      >
                        <option value="">Select</option>
                        <option value="CEO">CEO</option>
                        <option value="Dy. CEO">Dy. CEO</option>
                        <option value="Independent Director">Independent Director</option>
                        <option value="COO">COO</option>
                        <option value="Dy. COO">Dy. COO</option>
                        <option value="Asst. / Dy. GM">Asst. / Dy. GM</option>
                        <option value="President">President</option>
                        <option value="Vice-President">Vice-President</option>
                        <option value="Asst. Vice President">Asst. Vice President</option>
                        <option value="Manager">Manager</option>
                        <option value="Head">Head</option>
                        <option value="Dy. / Asst. Manager">Dy. / Asst. Manager</option>
                        <option value="Sr. Executive">Sr. Executive</option>
                        <option value="">None</option>
                      </select>
                    </div>
                  </div>
  
                  {/* Authorised Signatory */}
                  <div className="row mb-3">
                    <label htmlFor="is_authorised_signatory" className="col-md-3 col-form-label">Authorised Signatory</label>
                    <div className="col-md-9">
                      <select
                        className="form-select"
                        name="is_authorised_signatory"
                        id="is_authorised_signatory"
                        value={stakeholder.is_authorised_signatory}
                        readOnly
                      >
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
  
                  {/* Type of Signing Authority */}
                  <div className="row mb-3">
                    <label htmlFor="type_of_signing_authority" className="col-md-3 col-form-label">Type of Signing Authority</label>
                    <div className="col-md-9">
                      <select
                        className="form-select"
                        name="type_of_signing_authority"
                        id="type_of_signing_authority"
                        value={stakeholder.type_of_signing_authority}
                        readOnly
                      >
                        <option value="">Select</option>
                        <option value="Single / Sole">Single / Sole</option>
                        <option value="Joint">Joint</option>
                        <option value="Limited">Limited</option>
                      </select>
                    </div>
                  </div>
  
                  {/* PEP Name */}
                  <div className="mb-3 row">
                    <label htmlFor="pep_name" className="col-md-3 col-form-label">
                      PEP Name <span className="text-muted ms-2">(Optional)</span>
                    </label>
                    <div className="col-md-9">
                      <input
                        className="form-control"
                        type="text"
                        name="pep_name"
                        id="pep_name"
                        placeholder=""
                        value={stakeholder.pep_name}
                        readOnly
                      />
                    </div>
                  </div>
  
                  {/* Position Held */}
                  <div className="mb-3 row">
                    <label htmlFor="position_held" className="col-md-3 col-form-label">
                      Position Held <span className="text-muted ms-2">(Optional)</span>
                    </label>
                    <div className="col-md-9">
                      <input
                        className="form-control"
                        type="text"
                        name="position_held"
                        id="position_held"
                        placeholder=""
                        value={stakeholder.position_held}
                        readOnly
                      />
                    </div>
                  </div>
  
                  {/* Name of PEP Relative/Associate */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">Name of PEP Relative/Associate</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        value={stakeholder.relative_pep_name}
                        className="form-control shadow-sm"
                        placeholder=""
                        readOnly
                      />
                    </div>
                  </div>
  
                  {/* Relationship with PEP Name */}
                  <div className="row mb-3">
                    <label className="col-md-3 col-form-label text-start">Relationship with PEP Name</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        value={stakeholder.relationship_with_pep}
                        className="form-control shadow-sm"
                        placeholder=""
                        readOnly
                      />
                    </div>
                  </div>
                </fieldset>
  
                {/* Identity Section */}
                <fieldset
                  style={{
                    textAlign: "left",
                    display: currentStep === 1 ? "block" : "none",
                    marginBottom: "20px",
                  }}
                >
                  <div
                    style={{
                      margin: "10px",
                      padding: "20px",
                      borderRadius: "10px",
                      boxShadow: "0px 0px 20px #748292",
                      transition: "all 0.5s ease-in-out",
                    }}
                  >
                    <h6 className="text-start" style={{ marginBottom: "0.7rem" }}>
                      Identity {index + 1}
                    </h6>
                    <hr
                      style={{
                        border: "1px solid #748292",
                        margin: "5px",
                        width: "100%",
                      }}
                    />
  
                    {/* CPR / ID / Social Security Number */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        CPR / ID / Social Security Number issued by Govt.
                      </label>
                      <div className="col-md-9">
                        <input
                          className="form-control shadow-sm"
                          placeholder=""
                          value={stakeholder.government_id}
                          readOnly
                        />
                      </div>
                    </div>
  
                    {/* Date of Birth */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        Date of Birth *
                      </label>
                      <div className="col-md-9">
                        <input
                          type="date"
                          className="form-control shadow-sm"
                          value={formatDate(stakeholder.date_of_birth)}
                          required
                          readOnly
                        />
                      </div>
                    </div>
  
                    {/* Passport Number */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">Passport Number</label>
                      <div className="col-md-9">
                        <input
                          type="text"
                          className="form-control shadow-sm"
                          placeholder=""
                          value={stakeholder.passport_number}
                          readOnly
                        />
                      </div>
                    </div>
  
                    {/* Date of Issue */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        Date of Issue
                      </label>
                      <div className="col-md-9">
                        <input
                          type="date"
                          className="form-control shadow-sm"
                          value={formatDate(stakeholder.passport_issue_date)}
                          readOnly
                        />
                      </div>
                    </div>
  
                    {/* Expiry Date */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        Expiry Date
                      </label>
                      <div className="col-md-9">
                        <input
                          type="date"
                          className="form-control shadow-sm"
                          value={formatDate(stakeholder.passport_expiry_date)}
                          readOnly
                        />
                      </div>
                    </div>
  
                    {/* Country Issued By */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">Country Issued By</label>
                      <div className="col-md-9">
                        <input
                          type="email"
                          className="form-control shadow-sm"
                          placeholder=""
                          value={stakeholder.issued_by}
                          readOnly
                        />
                      </div>
                    </div>
  
                    {/* Resident of Bahrain */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        Resident of Bahrain
                      </label>
                      <div className="col-md-9">
                        <select
                          className="form-select shadow-sm"
                          value={stakeholder.resident_of_baharain}
                          readOnly
                        >
                          <option value="">Select</option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </div>
                    </div>
  
                    {/* Bahrain Residence Permit Number */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">Bahrain Residence Permit Number</label>
                      <div className="col-md-9">
                        <input
                          type="text"
                          name="bararin_residence_permit_number"
                          className="form-control shadow-sm"
                          placeholder=""
                          value={stakeholder.bararin_residence_permit_number}
                          readOnly
                        />
                      </div>
                    </div>
  
                    {/* Expiry Date */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        Expiry Date
                      </label>
                      <div className="col-md-9">
                        <input
                          type="date"
                          name="bararin_residence_permit_expiry_date"
                          className="form-control shadow-sm"
                          value={formatDate(stakeholder.bararin_residence_permit_expiry_date)}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </fieldset>
  
                {/* Attachments Section */}
                <fieldset
                  style={{
                    padding: "20px",
                    display: currentStep === 2 ? "block" : "none",
                    marginBottom: "20px",
                  }}
                >
                  <div
                    style={{
                      padding: "20px",
                      borderRadius: "10px",
                      boxShadow: "0px 0px 20px #748292",
                      transition: "all 0.5s ease-in-out",
                    }}
                  >
                    <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
                      Attachments {index + 1}
                    </h6>
                    <hr
                      style={{
                        border: "1px solid #748292",
                        margin: "5px",
                        width: "100%",
                      }}
                    />
  
                    {/* Passport Copy (First Page) */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        Passport Copy (First Page)
                      </label>
                      <div className="col-md-9">
                        <input
                          type="file"
                          className="form-control shadow-sm"
                          accept=".pdf"
                          readOnly={stakeholder.passport_first}
                        />
                        {stakeholder.passport_first && (
                          <span
                            className="badge badge-success"
                            style={{
                              marginTop: "10px",
                              backgroundColor: "green",
                            }}
                          >
                            Submitted
                          </span>
                        )}
                      </div>
                    </div>
  
                    {/* Passport Copy (Last Page) */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        Passport Copy (Last Page)
                      </label>
                      <div className="col-md-9">
                        <input
                          type="file"
                          className="form-control shadow-sm"
                          accept=".pdf"
                          readOnly={stakeholder.passport_last}
                        />
                        {stakeholder.passport_last && (
                          <span
                            className="badge badge-success"
                            style={{
                              marginTop: "10px",
                              backgroundColor: "green",
                            }}
                          >
                            Submitted
                          </span>
                        )}
                      </div>
                    </div>
  
                    {/* CPR Front Copy (Optional) */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        CPR Front Copy (Optional)
                      </label>
                      <div className="col-md-9">
                        <input
                          type="file"
                          className="form-control shadow-sm"
                          accept=".pdf"
                          readOnly={stakeholder.cpr_front}
                        />
                        {stakeholder.cpr_front && (
                          <span
                            className="badge badge-success"
                            style={{
                              marginTop: "10px",
                              backgroundColor: "green",
                            }}
                          >
                            Submitted
                          </span>
                        )}
                      </div>
                    </div>
  
                    {/* CPR Back Copy (Optional) */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        CPR Back Copy (Optional)
                      </label>
                      <div className="col-md-9">
                        <input
                          type="file"
                          className="form-control shadow-sm"
                          accept=".pdf"
                          readOnly={stakeholder.cpr_back}
                        />
                        {stakeholder.cpr_back && (
                          <span
                            className="badge badge-success"
                            style={{
                              marginTop: "10px",
                              backgroundColor: "green",
                            }}
                          >
                            Submitted
                          </span>
                        )}
                      </div>
                    </div>
  
                    {/* Residence Permit Certificate (Optional) */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        Residence Permit Certificate (Optional)
                      </label>
                      <div className="col-md-9">
                        <input
                          type="file"
                          className="form-control shadow-sm"
                          accept=".pdf"
                          readOnly={stakeholder.reslidence_permit_certificate}
                        />
                        {stakeholder.reslidence_permit_certificate && (
                          <span
                            className="badge badge-success"
                            style={{
                              marginTop: "10px",
                              backgroundColor: "green",
                            }}
                          >
                            Submitted
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </fieldset>
              </React.Fragment>
            ))
          )}
        </Form>
      </Container>
  
      {/* Action buttons */}
      <div className="action-button-container" style={{ textAlign: "center" }}>
        <button
          type="button"
          className="action-button-previous"
          onClick={handlePrevious}
          style={{ display: currentStep === 0 ? 'none' : 'block' }}
        >
          Previous
        </button>
  
        {currentStep === steps.length - 1 ? (
          <button
            type="button"
            className="action-button"
            onClick={handleSubmit}
          >
            Next
          </button>
        ) : (
          <button
            type="button"
            className="action-button"
            onClick={handleNext}
            style={{ display: currentStep === steps.length - 1 ? 'none' : 'block' }}
          >
            Next
          </button>
        )}
      </div>

      {/* Add/Edit Stakeholder Modal */}
      <Modal show={showAddModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{isAddingNew ? 'Add New Stakeholder' : 'Edit Stakeholder'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Basic Information */}
            <h5>Basic Information</h5>
            <div className="row mb-3">
              <Form.Label className="col-md-3">Full Name </Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="text"
                  name="family_name"
                  value={formState.family_name}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Given Name</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="text"
                  name="given_name"
                  value={formState.given_name}
                  onChange={handleInputChange}
                  placeholder=""
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">% Ownership </Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="text"
                  name="percentage_of_ownership"
                  value={formState.percentage_of_ownership}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Role as Director </Form.Label>
              <div className="col-md-9">
                <Form.Select
                  name="role_as_director"
                  value={formState.role_as_director}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="Executive Director">Executive Director</option>
                  <option value="Non-Executive Director">Non-Executive Director</option>
                  <option value="Independent Director">Independent Director</option>
                  <option value="Other">Other</option>
                </Form.Select>
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Position </Form.Label>
              <div className="col-md-9">
                <Form.Select
                  name="position"
                  value={formState.position}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="CEO">CEO</option>
                  <option value="Dy. CEO">Dy. CEO</option>
                  <option value="Independent Director">Independent Director</option>
                  <option value="COO">COO</option>
                  <option value="Dy. COO">Dy. COO</option>
                  <option value="Asst. / Dy. GM">Asst. / Dy. GM</option>
                  <option value="President">President</option>
                  <option value="Vice-President">Vice-President</option>
                  <option value="Asst. Vice President">Asst. Vice President</option>
                  <option value="Manager">Manager</option>
                  <option value="Head">Head</option>
                  <option value="Dy. / Asst. Manager">Dy. / Asst. Manager</option>
                  <option value="Sr. Executive">Sr. Executive</option>
                  <option value="">None</option>
                </Form.Select>
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Authorised Signatory</Form.Label>
              <div className="col-md-9">
                <Form.Select
                  name="is_authorised_signatory"
                  value={formState.is_authorised_signatory}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Form.Select>
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Signing Authority</Form.Label>
              <div className="col-md-9">
                <Form.Select
                  name="type_of_signing_authority"
                  value={formState.type_of_signing_authority}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select</option>
                  <option value="Single / Sole">Single / Sole</option>
                  <option value="Joint">Joint</option>
                  <option value="Limited">Limited</option>
                </Form.Select>
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">PEP Name </Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="text"
                  name="pep_name"
                  value={formState.pep_name}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Position Held </Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="text"
                  name="position_held"
                  value={formState.position_held}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Name of PEP Relative/Associate</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="text"
                  name="relative_pep_name"
                  value={formState.relative_pep_name}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Relationship with PEP Name</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="text"
                  name="relationship_with_pep"
                  value={formState.relationship_with_pep}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
            </div>

            {/* Identity Information */}
            <h5 className="mt-4">Identity Information</h5>
            <div className="row mb-3">
              <Form.Label className="col-md-3">CPR / ID / Social Security Number issued by Govt </Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="text"
                  name="government_id"
                  value={formState.government_id}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Date of Birth</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="date"
                  name="date_of_birth"
                  value={formState.date_of_birth}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Passport Number</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="text"
                  name="passport_number"
                  value={formState.passport_number}
                  onChange={handleInputChange}
                  placeholder=""
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Date of Issue</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="date"
                  name="passport_issue_date"
                  value={formState.passport_issue_date}
                  onChange={handleInputChange}
                  placeholder=""
                />
              </div>
            </div>
            
            <div className="row mb-3">
              <Form.Label className="col-md-3">Expiry Date</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="date"
                  name="passport_expiry_date"
                  value={formState.passport_expiry_date}
                  onChange={handleInputChange}
                  placeholder=""
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Country Issued By</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="text"
                  name="issued_by"
                  value={formState.issued_by}
                  onChange={handleInputChange}
                  placeholder=""
                />
              </div>
            </div>

             {/* Resident of Bahrain */}
             <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        Resident of Bahrain
                      </label>
                      <div className="col-md-9">
                        <select
                          name="resident_of_baharain"
                          className="form-select shadow-sm"
                          value={formState.resident_of_baharain}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </div>
                    </div>
  
                    {/* Bahrain Residence Permit Number */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">Bahrain Residence Permit Number</label>
                      <div className="col-md-9">
                        <input
                          type="text"
                          name="bararin_residence_permit_number"
                          className="form-control shadow-sm"
                          placeholder=""
                          value={formState.bararin_residence_permit_number}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
  
                    {/* Expiry Date */}
                    <div className="row mb-3">
                      <label className="col-md-3 col-form-label text-start">
                        Expiry Date
                      </label>
                      <div className="col-md-9">
                        <input
                          type="date"
                          name='bararin_residence_permit_expiry_date'
                          className="form-control shadow-sm"
                          value={formatDate(formState.bararin_residence_permit_expiry_date)}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

            {/* Attachments */}
            <h5 className="mt-4">Attachments</h5>
            <div className="row mb-3">
              <Form.Label className="col-md-3">Passport First Page</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="file"
                  name="passport_first"
                  onChange={handleFileChange}
                  accept=".pdf"
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Passport Last Page</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="file"
                  name="passport_last"
                  onChange={handleFileChange}
                  accept=".pdf"
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">CPR Front (Optional)</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="file"
                  name="cpr_front"
                  onChange={handleFileChange}
                  accept=".pdf"
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">CPR Back (Optional)</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="file"
                  name="cpr_back"
                  onChange={handleFileChange}
                  accept=".pdf"
                />
              </div>
            </div>

            <div className="row mb-3">
              <Form.Label className="col-md-3">Residence Permit (Optional)</Form.Label>
              <div className="col-md-9">
                <Form.Control
                  type="file"
                  name="reslidence_permit_certificate"
                  onChange={handleFileChange}
                  accept=".pdf"
                />
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveStakeholder} disabled={loading}>
            {loading ? 'Saving...' : 'Save Stakeholder'}
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="top-right" autoClose={3000} />

    </div>
    
  );
};

export default StakeHolderDetails;